module.exports = __webpack_public_path__ + "assets/ddbedeb89fe0969073d0341142d2f588.png";